export default "__VITE_ASSET__COb3CRnb__"